import { TextStyle } from 'pixi.js'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { TextStyleService } from 'services/TextStyleService'

import Sprite from '../Sprite'

export default class SymbolValuePopup extends PIXI.Container{
  constructor(data) {
    super()
    this.bg = new Sprite({ texture: game.getTextureFromAtlases(data.texture) })
    this.addChild(this.bg)
    this.width = data.width / 2
    this.height = data.height / 2
    this.style = new PIXI.TextStyle({ fontSize: 25, fill: data.color })
    if(data.customStyle){
      TextStyleService.init()
      this.style = new TextStyle(TextStyleService.getText(data.customStyle))
    }
    this.createPopup(data)
  }

  cleanContainer() {
    this.children.splice(1, this.children.length)
    this.style.fontSize = 25
  }

  createPopup(data) {
    signal.on('SHOW-SYMBOL-VALUE:IN', ({ currentSymbol, numberOfSymbolValues, positionX, positionY }) => {
      this.cleanContainer()
      this.setPosition(positionX, positionY, data)
      this.createSymbolValueText(currentSymbol, numberOfSymbolValues)
    })
  }

  setPosition(positionX, positionY, data) {
    let shiftDistance = parseInt(data.positionShift)
    if (data.shiftingToThe === 'left') {
      this.x = (positionX * this.width) + shiftDistance
    }
    else if (data.shiftingToThe === 'spaceBetween'){
      switch (positionX) {
        case 0 : this.x = (positionX * this.width)
          break
        case 1 : this.x = (positionX * this.width) + shiftDistance
          break
        case 2 : this.x = (positionX * this.width) + shiftDistance * 2
          break
        case 3 : this.x = (positionX * this.width) + shiftDistance * 3
          break
        case 4 : this.x = (positionX * this.width) + shiftDistance * 4
          break
      }
    }
    else if (data.shiftingToThe === 'differentSpaces'){
      let spaces = data.spaces.split(',')
      switch (positionX) {
        case 0 : this.x = (positionX * this.width)
          break
        case 1 : this.x = (positionX * this.width) + parseInt(spaces[0])
          break
        case 2 : this.x = (positionX * this.width) + parseInt(spaces[1])
          break
        case 3 : this.x = (positionX * this.width) + parseInt(spaces[2])
          break
        case 4 : this.x = (positionX * this.width) + parseInt(spaces[3])
          break
      }
    }
    else {
      this.x = (positionX * this.width)
    }
    this.y = (positionY * this.height)
  }

  createSymbolValueText(currentSymbol, numberOfSymbolValues) {
    const current = game.models.SpinModel.get().action
    for (let i = 6 - numberOfSymbolValues; i < 6; i++){
      this.payout = currentSymbol[i]
      this.bet = game.models.BetModel.getValue()
      this.value = i + ' - ' + FormatService.currency(this.payout * this.bet)
      if (current === 'freebet') {
        this.bet = game.models.FreebetsModel.get().betValue * game.models.SpinModel.get().lines
      }
      if(numberOfSymbolValues === 1){
        this.payout = currentSymbol[Object.keys(currentSymbol)[0]]
        this.value = Object.keys(currentSymbol)[0] + ' - ' + FormatService.currency(this.payout * this.bet)
        this.text = new PIXI.Text(this.value, this.style)
        this.text.y = (this.height - this.text.height * 0.55)
        this.text.x = 45
      }
      else if(numberOfSymbolValues === 3){
        this.text = new PIXI.Text(this.value, this.style)
        this.text.y = ((i - 2) * this.height / numberOfSymbolValues) + (this.height / 5)
      }
      else  if (numberOfSymbolValues === 4){
        this.text = new PIXI.Text(this.value, this.style)
        this.text.y = ((i - 1) * this.height / numberOfSymbolValues) + (this.height / 4)
      }
      this.text.x = 35
      this.addChild(this.text)
    }
    this.checkTextFit()
  }

  checkTextFit() {
    if (this.width < this.text.width * 0.7){
      this.style.fontSize = this.style.fontSize * 0.7
      this.checkTextFit ()
    }
  }
}
